import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";

var NumberHelper =
/*#__PURE__*/
function () {
  function NumberHelper() {
    _classCallCheck(this, NumberHelper);
  }

  _createClass(NumberHelper, [{
    key: "RoundUpToTheNearest",
    value: function RoundUpToTheNearest(value, step) {
      step || (step = 1.0);
      var inv = 1.0 / step;
      return parseFloat(Math.round(value * inv) / inv).toFixed(1);
    }
  }, {
    key: "numberWithCommas",
    value: function numberWithCommas(x) {
      if (x == null) return null;
      return x.toLocaleString('en-US');
    }
  }]);

  return NumberHelper;
}();

export default new NumberHelper();